module.exports = __webpack_public_path__ + "static/media/ClockIcon.7cf1472f.svg";